import React, { useState, useEffect } from "react";
import styles from "./row.module.sass";
import Checkbox from "../../../../Checkbox";
import Icon from "../../../../Icon";
import Control from './Control'
import { Link, useParams } from "react-router-dom";
import cn from "classnames";
import Switch from "../../../../Switch";

const Row = ({ item, className, access, value, onChange, index, type, setValue }) => {

    const {appid} = useParams()

    return (
        <>
            <div className={styles.row}>
                <div className={styles.col}>
                    <div className={styles.item}>{item?.createdAt}</div>
                </div>
                <div className={styles.col}>
                    <div className={styles.item}>{item?.time}</div>
                </div>
                <div className={styles.col}>₹ {item?.amount}</div>
                <div className={styles.col}>{item?.recipientTransactionContact}</div>
                <div className={styles.col}>
                    <div className={cn(styles.pills, {[styles.green] : (item?.walletTransactionType === 'Debit')}, {[styles.red] : (item?.walletTransactionType === 'Credit')})}>{item?.walletTransactionType}</div>
                </div>
                <div className={styles.col}>{item?.sourceWalletName}</div>
                <div className={styles.col}>{item?.walletTransactionRecepientName}</div>
                <div className={styles.col}>{item?.walletTransactionPurposeName}</div>
                <div className={styles.col}>-</div>
                <div className={styles.col}>
                    <div className={cn(styles.pills, {[styles.green] : (item?.status === 'Completed')}, {[styles.red] : (item?.status === 'In-Progress')})}>{item?.status}</div>
                </div>
                <div className={styles.col}>{item?.walletTransactionPurposeName}</div>
            </div>
        </>
    );
};

export default Row;
